import { QueryKeys } from "@/constants/Query";
import { useApi } from "@/hooks/useApi";
import axiosInstance from "@/lib/axios";
import type { RequestGroup, ServiceRequest } from "@curai/js-fhir-tools";

interface CompendiumSearchParams {
  patientId: string;
  labNetwork: (typeof ServiceRequest.LAB_NETWORKS)[keyof typeof ServiceRequest.LAB_NETWORKS];
  searchTerm: string;
  compendiumId: string;
  requestGroupId?: string;
}

export interface CompendiumSearchItem {
  display: string;
  code: string;
  labNetwork: (typeof RequestGroup.LAB_NETWORKS)[keyof typeof RequestGroup.LAB_NETWORKS];
  price?: number;
  duplicate: boolean;
}

interface CompendiumSearchResponse {
  tests: CompendiumSearchItem[];
}

export const useCompendiumSearch = ({
  patientId,
  labNetwork,
  searchTerm,
  compendiumId,
  requestGroupId,
}: CompendiumSearchParams) => {
  return useApi<CompendiumSearchResponse>({
    queryOptions: {
      enabled:
        searchTerm?.length > 2 && Boolean(labNetwork) && Boolean(compendiumId),
      queryFn: async () => {
        const response = await axiosInstance.get<CompendiumSearchResponse>(
          "/labs/compendium/tests/search",
          { params: { searchTerm, compendiumId, labNetwork, requestGroupId } },
        );

        return response.data;
      },
      queryKey: QueryKeys.Patient.Chart.Labs.SEARCH_COMPENDIUM({
        patientId,
        labNetwork,
        compendiumId,
        searchTerm,
        requestGroupId,
      }),
      staleTime: requestGroupId ? 0 : Number.POSITIVE_INFINITY,
    },
  });
};
